export default "__VITE_ASSET__YeBG3Be5__"